import { inject as o, computed as r, unref as t } from "vue";
import { buildProp as i } from "./index601.js";
import { componentSizes as n } from "./index684.js";
const c = i({
  type: String,
  values: n,
  required: !1
}), s = /* @__PURE__ */ Symbol("size"), S = () => {
  const e = o(s, {});
  return r(() => t(e.size) || "");
};
export {
  s as SIZE_INJECTION_KEY,
  S as useGlobalSize,
  c as useSizeProp
};
